@use "@ebay/skin/dist/badge/badge";
.badge {
  background-color: var(--color-background-inverse);
  margin-inline-end: 3px;
  padding: 7px 6px;
  position: relative;
  top: -2px;
}

.component {
  margin-block: var(--spacing-400);

  h1 {
    margin-block: 24px 16px;
  }
}

.tabs {
  margin-top: 0;
}

.pagination {
  border-top: 1px dashed var(--color-neutral-300);
  display: flex;
  justify-content: space-between;
  margin-block: var(--spacing-200);
  padding-block: var(--spacing-200);
}

.pagination > a:last-child {
  text-align: right;
}

.pagination > a {
  align-items: center;
  color: var(--color-foreground-secondary);
  display: inline-flex;
  font-size: var(--font-size-small);
  gap: var(--spacing-50);
  text-decoration: none;
}

.pagination > a:visited {
  color: var(--color-foreground-secondary);
}
.pagination > a:hover {
  color: var(--color-foreground-primary);
  text-decoration: underline;
}
